module.exports = __webpack_public_path__ + "static/denis-8fb5ce51d60be338c0df834973dba346.jpg";